exports.components = {
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-qr-code-generator-js": () => import("./../../../src/pages/qr-code-generator.js" /* webpackChunkName: "component---src-pages-qr-code-generator-js" */),
  "component---src-pages-stats-js": () => import("./../../../src/pages/stats.js" /* webpackChunkName: "component---src-pages-stats-js" */)
}

